var customerAnswers = {};

function addAnswer(button) {
    let container = button.parentElement.parentElement;
    let question = container.id;
    let answer = container.querySelector("input:checked").value;
    customerAnswers[question] = answer;

    return answer
}

function nextScreen(button) {
    let currentId = button.dataset.current;
    let nextId = button.dataset.next;
    let screen = document.getElementById(nextId);

    if (nextId == 'last') {
        answerScreen();
    }

    screen.style.left = '0px';
    scrollToTop();
    setTimeout(() => { changePosition(currentId, nextId); }, 500)
    setTimeout(function () {
        document.getElementById(currentId).style.display = 'none';
    }, 1000)
}

function backScreen(button) {
    let currentId = button.dataset.current;
    let nextId = button.dataset.next;
    let screen = document.getElementById(currentId);

    document.getElementById(nextId).style.display = 'block';
    screen.style.left = '-9999px';
    scrollToTop();
    changePosition(currentId, nextId);

    hideInspiration();
}

function answerScreen() {
    let answer1 = customerAnswers.q1;
    let answer2 = customerAnswers.q2;
    let answer3 = customerAnswers.q3;
    let answer4 = customerAnswers.q4;

    let answerContainer = document.getElementById('answer');
    answerContainer.innerHTML = answers[answer1][answer2][answer3][answer4];

    displayInspiration();
    addDropdownFunction();
}

function changePosition(current, next) {
    let currentId = current;
    let nextId = next;

    let currentScreen = document.getElementById(currentId);
    let nextScreen = document.getElementById(nextId);

    nextScreen.style.position = 'relative';
    nextScreen.style.opacity = 1;
    currentScreen.style.position = 'absolute';
    currentScreen.style.opacity = 0;
}

function checkNoOption() {
    let hide = document.querySelector("[data-answer='clipin']");

    if (customerAnswers.q2 == 'short' && customerAnswers.q3 == 'thicker') {
        hide.style.display = 'none';
    }
    else {
        hide.style.display = 'flex';
    }
}

function scrollToTop() {
    document.body.scrollTop = 100; // For Safari
    document.documentElement.scrollTop = 100; // For Chrome, Firefox, IE and Opera
}

// dropdown functions
function addDropdownFunction() {
    let button = document.querySelector('#dropdown-btn');

    if (button) {
        button.addEventListener('click', openAndClose);
    }
}

function openAndClose() {
    let sign = document.querySelector('.sign');
    let text = document.querySelector('.sub-text')

    document.querySelector('#dropdown-hidden').classList.toggle('hidden');

    if (sign.innerText === '+ ') {
        sign.innerText = "- ";
        text.innerText = '(click to close)';
    } else {
        sign.innerText = "+ ";
        text.innerText = '(click to open)';
    }
}

// Inspiration functions
function displayInspiration() {
    let answerId = document.querySelector('.answer').innerText.toLowerCase().replaceAll(" ", "-");
    let element = document.querySelector(`#${answerId}`);

    element.style.position = 'relative';
    element.style.left = '0px';
}

function hideInspiration() {
    let inspirationsContainer = document.querySelectorAll(".inspiration-outer");

    for (let container of inspirationsContainer) {
        if (container.hasAttribute('style')) {
            container.removeAttribute('style');
        }
    }
}